import { KreateUTxO } from "kreate-common/modules/business-types";
import {
  DisplayableError,
  useDisplayableError,
} from "kreate-common/modules/displayable-error";
import { httpGet$GetProtocolParams } from "kreate-server/commands/GetProtocolParams/fetcher";
import useSWR from "swr";

export function useProtocolParamsUTxO(): [
  KreateUTxO | undefined,
  DisplayableError | undefined
] {
  const { data, error } = useSWR(
    ["e0dd192d-d780-445c-b5bb-d652c3cf8753"],
    async () => await httpGet$GetProtocolParams("/api/v1/utxo/protocol-params")
  );
  const displayableError = useDisplayableError(
    error,
    "Failed to fetch protocol-params"
  );
  return [data, displayableError];
}
